import React, { useState, useEffect, useCallback } from 'react';
import { getCompletedBiddings } from "../components/api"
import { BiddingListItem } from "../components/BiddingListItem"
import { BiddingCard } from '../components';
import '../styles/bidding-list.scss';

export const CompletedBiddings = () => {
    const [biddings, setBiddings] = useState([]);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [selectedBiddingId, setSelectedBiddingId] = useState(null);

    const biddingsLimit = 8;

    const loadMoreBiddings = useCallback(async () => {
        if (loading || !hasMore) return;
        setLoading(true);

        try {
            const data = await getCompletedBiddings(biddingsLimit, page * biddingsLimit);

            if (data && data.length > 0) {
                setBiddings(prevBiddings => [...prevBiddings, ...data]);
                setPage(prevPage => prevPage + 1);
                if (data.length < biddingsLimit) {
                    setHasMore(false);
                }
            } else {
                setHasMore(false);
            }
        } catch (error) {
            console.error("Ошибка получения торгов:", error);
        } finally {
            setLoading(false);
        }
    }, [loading, hasMore, page, biddingsLimit]);

    useEffect(() => {
        loadMoreBiddings();
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (
                window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100
            ) {
                loadMoreBiddings();
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [loadMoreBiddings]);

    const closeBiddingCard = () => {
        setSelectedBiddingId(null);
    }

    return (
        <div className='bidding-list'>
            <h2>Завершенные аукционы</h2>
            {biddings.map(bidding => (
                <BiddingListItem key={bidding.id} data={bidding} status={"completed"} onClick={() => setSelectedBiddingId(bidding.id)} />
            ))}
            {loading && <p>Загрузка...</p>}
            {!hasMore && !loading && <p style={{ textAlign: 'center' }}> </p>}
            {selectedBiddingId && <BiddingCard biddingId={selectedBiddingId} onClose={() => closeBiddingCard()} />}
        </div>
    )
};